import { useSelector } from 'react-redux';
import { selectAgentDisplayTimezone } from 'app/modules/session/selectors';
import { selectOrgDisplayTimezone } from 'app/modules/orgSettings/selectors';
import { useEffect } from 'react';
import { setDefaultTimezoneOptions } from 'app/shared/utils/date';

export const useTimezoneSync = () => {
  const agentTimezone = useSelector(selectAgentDisplayTimezone);
  const orgTimezone = useSelector(selectOrgDisplayTimezone);
  const timezone = agentTimezone || orgTimezone;

  useEffect(() => {
    if (timezone) {
      setDefaultTimezoneOptions({ timezone, showTimezone: true });
    } else {
      setDefaultTimezoneOptions({});
    }
  }, [timezone]);

  return timezone;
};
